import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';
import { performAction } from '../../actions';

import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './Hooi_Default.module.css';

import { DoubleCheck } from '../../../../containers/App/Components/DoubleCheck/DoubleCheck';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { setVehicleProperty } from '../../../Vehicles/actions';
dayjs.extend(customParseFormat);

const ranges = {
  MediumSeaGreen: [2, 4],
  DarkOrange: [5, 29],
  Crimson: [30, Infinity],
};
const TASK_REMARK_TYPE = 'HOOI_NEW_task_license_plate_order_install';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
  }
`;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_NEW_license_plate_order_installComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }





  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const { vehicle, setProperty } = this.props;
  
          if (!vehicle || !prevProps.vehicle) return;

    // Voeg deze check toe
    const watchProps = [
      'is_license_plate_present',
      'TDN_message_to_client',
      'HOOI_NEW_tdn_received',
      'HOOI_NEW_order_licenseplate',
      'HOOI_NEW_attach_licenseplate',
      'HOOI_NEW_licenseplate_ordered',
      'order_key',
    ];
  
 const propChanged = watchProps.some(
    prop => vehicle?.[prop] !== prevProps.vehicle?.[prop]
  );  
    if (propChanged) {
      console.log('One of the watched properties changed:', watchProps);
      const today = new Date().toISOString().split('T')[0];
    
        setProperty('HOOI_NEW_tdn_waiting', today);
    
    }


  
  }
  
     dateDifference(HOOI_NEW_tdn_waiting) {
      const now = dayjs();
        const createdDate = HOOI_NEW_tdn_waiting || this.propertyValue('HOOI_NEW_tdn_waiting' || now);
        if (!createdDate) return 0;
  
        const created = dayjs(createdDate, 'YYYY-MM-DD'); // <-- correct parse format
    
        if (!created.isValid()) return 0;
    
        const diff = now.diff(created, 'day');
        return diff;
      }

  get vehicle() {
    return this.props.cell.vehicle;
  }
  get doubleCheckProps() {
    return ['HOOI_NEW_order_licenseplate', 'HOOI_NEW_attach_licenseplate'];
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  disableConfirmation() {
    const bothEmpty = this.doubleCheckProps.every(
      prop => !this.props.vehicle[prop]
    );
    return bothEmpty;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>

          <Container>
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  <DoubleCheck
                    key={'is_license_plate_present'}
                    name={'is_license_plate_present'}
                    yesNo
                    vehicle={this.props.vehicle}
                  />
                </Cell>
              </Row>
              {this.propertyValue('is_license_plate_present') === '1' && (
                <>
                  <Row>
                    <Cell>
                      <DoubleCheck
                        key={'HOOI_NEW_licenseplate_ordered'}
                        name={'HOOI_NEW_licenseplate_ordered'}
                        vehicle={this.props.vehicle}
                      />
                    </Cell>
                  </Row>
                  {this.propertyValue('HOOI_NEW_licenseplate_ordered') === '1' && (
                    <>
                      <Row>
                        <Cell>
                          <DoubleCheck
                            key={'HOOI_NEW_attach_licenseplate'}
                            name={'HOOI_NEW_attach_licenseplate'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>
                    </>
                  )}
                </>
              )}
              {this.propertyValue('is_license_plate_present') === '0' && (
                <>
                  <Row>
                    <Cell>
                      <DoubleCheck
                        key={'TDN_message_to_client'}
                        name={'TDN_message_to_client'}
                        vehicle={this.props.vehicle}
                      />
                    </Cell>
                  </Row>
                  {this.propertyValue('TDN_message_to_client') === '1' && (
                    <>
                      <Row>
                        <Cell>
                          <DoubleCheck
                            key={'HOOI_NEW_tdn_received'}
                            name={'HOOI_NEW_tdn_received'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>
                      {this.propertyValue('HOOI_NEW_tdn_received') === '1' && (
                        <>
                          <Row>
                            <Cell>
                              <DoubleCheck
                                key={'HOOI_NEW_order_licenseplate'}
                                name={'HOOI_NEW_order_licenseplate'}
                                vehicle={this.props.vehicle}
                              />
                            </Cell>
                          </Row>
                          {this.propertyValue('HOOI_NEW_order_licenseplate') === '1' && (
                            <>
                              <Row>
                                <Cell>
                                  <DoubleCheck
                                    key={'HOOI_NEW_attach_licenseplate'}
                                    name={'HOOI_NEW_attach_licenseplate'}
                                    vehicle={this.props.vehicle}
                                  />
                                </Cell>
                              </Row>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              <HBox className="mt-3">
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    key={'modal'}
                    fullWidth={true}
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
              </HBox>
            </VBox>
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            disabled={this.disableConfirmation()}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderIcon(vehicle) {
    if (
      (vehicle.TDN_message_to_client == '1' && !vehicle.HOOI_NEW_tdn_received) ||
      (vehicle.HOOI_NEW_order_licenseplate === '1' && !vehicle.HOOI_NEW_attach_licenseplate) ||
      (vehicle.HOOI_NEW_licenseplate_ordered === '1' && !vehicle.HOOI_NEW_attach_licenseplate) 
        ) {
      return (
        <img
          src="https://vindat.indewal.nl/storage/documents/ac98742c-10cb-41c6-980f-952787ea0dbb.png"
          alt="Kleine afbeelding"
          style={{ width: '25px', height: '25px', margin: '5px' }}
        />
      );
    }

    return;
  }

  render() {
    const vehicle = this.vehicle;
    let message = '';
    const Date = vehicle?.HOOI_NEW_tdn_waiting || dayjs();

    const days = this.dateDifference(Date);
    if (vehicle.TDN_message_to_client === '1' && (!vehicle.HOOI_NEW_tdn_received || vehicle.HOOI_NEW_tdn_received === '0')) {
      message = 'Wacht op: TDN';
    } else if (vehicle.HOOI_NEW_order_licenseplate === '1' && !vehicle.HOOI_NEW_attach_licenseplate) {
      message = 'Wacht op: Kentekenplaat';
    } else if (vehicle.HOOI_NEW_licenseplate_ordered === '1' && !vehicle.HOOI_NEW_attach_licenseplate) {
      message = 'Wacht op: Kentekenplaat';
    }
   
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell />
          <Label count={days} ranges={ranges}>
                                {days}
                              </Label>{message}
          <CellButtons>
          {this.renderIcon(vehicle)}
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_NEW_license_plate_order_installComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

  function mapDispatchToProps(dispatch, ownProps) {
    return {
      dispatch,
      confirm(vehicle_id, regplate_code) {
        dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
      },
       setProperty(name, value) {
            dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
          },
    };
  }
  

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_NEW_license_plate_order_install = compose(
  withConnect,
  withRouter,
)(HOOI_NEW_license_plate_order_installComp);
